import { regex } from './common'
export default regex('alpha', /^[a-zA-Z\u00C0-\u00FF ]{1,100}$/)